import React, { useState } from "react";
import "./Header.css";
import { useNavigate, useLoaderData, Link } from "react-router-dom";
import logo from "../../assets/mooring-mate-logo.png";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Logout from "@mui/icons-material/Logout";
import ListItemIcon from "@mui/material/ListItemIcon";
import toast from "react-hot-toast";
import Instagram from "../../assets/instagram.png";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import { logout } from "../../services";

export const Header = ({ user }) => {
  const navigate = useNavigate();
  const data = useLoaderData();
  const baseUrl = process.env.REACT_APP_API_URL;

  const handleLogout = async () => {
    const res = await logout(user.token);

    // Always clear storage and redirect, even if API fails
    // This ensures user can always logout from frontend
    localStorage.removeItem("dockingmate");
    sessionStorage.removeItem("dockingmate");

    if(res === null || res?.status === false) {
      // API failed but we still logged out locally
      toast.success("Logged out successfully");
    }

    navigate("/login");
    return;
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleProfileNavigation = (role) => {
    navigate("/home/profile");
    return;
  };

  return (
    <nav className="header">
      <Container maxWidth="xl">
        <div className="header-content">
          <div className="dashboard-logo">
            <img
              className="landing-logo"
              src={logo}
              alt="Logo"
              onClick={() => navigate("/")}
            />
          </div>
          <div className="right-side-links">
            <Button
              onClick={() => navigate("/blog")}
              sx={{ color: "#000" }}
            >
              Blog
            </Button>
            {data === undefined && (
              <Link
                to="https://www.instagram.com/greenmate24/?hl=en"
                target="_blank"
                className="insta-link"
              >
                <img src={Instagram} />
              </Link>
            )}
            {user ? (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                {/* <Typography >{name}</Typography> */}
                <Tooltip title="Account settings">
                  <IconButton
                    onClick={handleClick}
                    size="small"
                    sx={{ ml: 0, p: 0 }}
                    aria-controls={open ? "account-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                  >
                    {data?.data?.profileImagePath ? (
                      <Avatar
                        className="user-avtar"
                        src={`${baseUrl}${data?.data?.profileImagePath}`}
                        sx={{ width: 32, height: 32 }}
                      ></Avatar>
                    ) : (
                      <Avatar className="user-avtar" sx={{ width: 32, height: 32 }}></Avatar>
                    )}
                  </IconButton>
                </Tooltip>
              </Box>
            ) : (
              <Button
                onClick={() => navigate("/login")}
                sx={{ color: "#000" }}
              >
                Login
              </Button>
            )}
          </div>
        </div>
      </Container>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            padding: "10px",
            borderRadius: "10px",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.1))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem
          className="user-item"
          onClick={() => handleProfileNavigation(user?.data?.role)}
          // disabled={true}
          // disabled={user?.data?.role === "admin"}
          PaperProps={{
            sx: {
              borderRadius: "10px",
            },
          }}
        >
          {data?.data?.profileImagePath ? (
            <Avatar
              src={`${baseUrl}${data?.data?.profileImagePath}`}
              sx={{ width: 32, height: 32 }}
            ></Avatar>
          ) : (
            <Avatar sx={{ width: 32, height: 32 }}></Avatar>
          )}{" "}
          Profile
        </MenuItem>
        <MenuItem
          className="user-item"
          onClick={() => navigate("/home/payment-account")}
        >
          <ListItemIcon>
            <AccountBalanceIcon fontSize="small" />
          </ListItemIcon>
          Account Info
        </MenuItem>

        <MenuItem className="user-item" onClick={handleLogout}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </nav>
  );
};
